import {useEffect, useState} from "react";
import {useUser} from "../../../auth/AuthProvider";
import axios from "axios";
import {ApiUrl} from "../../../auth/authMethods";
import {Avatar, Box, Card, CardContent, Divider, Grid, Typography,} from '@mui/material';
import {numberWithPoints} from "../../../utils/numberWithPoints";
import BasicLoader from "../../../component/BasicLoader/BasicLoader";
import ReceiptIcon from '@mui/icons-material/Receipt';
import LayersIcon from '@mui/icons-material/Layers';
import PeopleIcon from '@mui/icons-material/People';

export default function DefaultersSummary() {

    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState("");

    const {user} = useUser()

    useEffect(() => {
        axios.defaults.headers.common['Authorization'] = `Bearer ${user?.token}`;
        axios
            .get(`${ApiUrl}/dashboard/defaulters-summary`)
            .then(function (response) {
                setData(response.data);
                setIsLoading(false)
            })
    }, []);


    const summaryCards = [
        {
            title: 'Boletos - Quantidade',
            totalLabel: 'Total',
            overdueLabel: 'Vencidos',
            percentageLabel: 'Percentual',
            total: data?.totalBoletos,
            overdue: data?.totalBoletosVencidos,
            percentage: data?.porcentagemBoletosVencidos,
            icon: <ReceiptIcon/>,
            color: '#2196f3'
        },
        {
            title: 'Boletos - Valor',
            totalLabel: 'Total',
            overdueLabel: 'Vencidos',
            percentageLabel: 'Percentual',
            total: 'R$ ' + numberWithPoints(data?.totalValorBoletos),
            overdue: 'R$ ' + numberWithPoints(data?.totalValorBoletosVencidos),
            percentage: data?.porcentagemValorBoletosVencidos,
            icon: <ReceiptIcon/>,
            color: '#a28a1d'
        },
        {
            title: 'Lotes',
            totalLabel: 'Total',
            overdueLabel: 'Vencidos',
            percentageLabel: 'Percentual',
            total: data?.totalLotes,
            overdue: data?.totalLotesVencidos,
            percentage: data?.porcentagemLotesVencidos,
            icon: <LayersIcon/>,
            color: '#ff9800'
        },
        {
            title: 'Compradores',
            totalLabel: 'Total',
            overdueLabel: 'Inadimplentes',
            percentageLabel: 'Percentual',
            total: data?.totalCompradores,
            overdue: data?.totalCompradoresInadimplentes,
            percentage: data?.porcentagemCompradoresInadimplentes,
            icon: <PeopleIcon/>,
            color: '#f44336'
        }
    ];

    return <Box sx={{mt: -1}}>
        <Typography variant="h4" align="center" gutterBottom>
            Inadimplência
        </Typography>

        <Grid container spacing={3}>
            {isLoading ? (
                <Grid item xs={12}>
                    <BasicLoader height={15}/>
                </Grid>
            ) : (
                summaryCards.map((item, index) => (
                    <Grid item xs={12} md={3} key={index}>
                        <Card
                            variant="outlined"
                            sx={{
                                borderTop: `6px solid ${item.color}`,
                                boxShadow: 3,
                                transition: 'transform 0.2s',
                                '&:hover': {
                                    transform: 'scale(1.02)'
                                }
                            }}
                        >
                            <CardContent>
                                <Box display="flex" alignItems="center" mb={2}>
                                    <Avatar sx={{bgcolor: item.color, mr: 2}}>{item.icon}</Avatar>
                                    <Typography variant="h6" textAlign="center">{item.title}</Typography>
                                </Box>
                                <Divider sx={{mb: 2}}/>
                                <Box display="flex" justifyContent="center" gap={2} textAlign="center">
                                    <Typography><b>{item.totalLabel}:</b><br/> {item.total}</Typography>
                                    <Typography><b>{item.overdueLabel}:</b><br/> {item.overdue}</Typography>
                                </Box>
                                <Box display="flex" justifyContent="center" gap={2} textAlign="center" mt={2}>
                                    <Typography sx={{color: item.color, fontWeight: 'bold'}}>
                                        <b>{item.percentageLabel}:</b> {numberWithPoints(item.percentage, 2)}%
                                    </Typography>
                                </Box>
                            </CardContent>

                        </Card>
                    </Grid>
                ))
            )}
        </Grid>
    </Box>

}